import { render, staticRenderFns } from "./ReviewsTable.vue?vue&type=template&id=5a6f9c2e"
import script from "./ReviewsTable.vue?vue&type=script&lang=js"
export * from "./ReviewsTable.vue?vue&type=script&lang=js"
import style0 from "./ReviewsTable.vue?vue&type=style&index=0&id=5a6f9c2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports